<div class="cart relative">
  <button
    type="button"
    class="relative rounded-md p-1 px-3"
    [ngClass]="dropdownCart.dropdownOpened ? 'bg-gray-100' : ''"
    (click)="dropdownCart.toggle($event)">
    <fa-icon class="text-xl text-gray-500" [icon]="faCartShopping"></fa-icon>

    <ng-container *ngIf="cart">
      <span
        class="absolute -top-1 -right-1 rounded-full bg-red-500 py-[2px] px-[6px] text-xs font-medium text-white"
        *ngIf="cart.totalCartItems">
        {{ cart.totalCartItems }}</span
      >
    </ng-container>
  </button>
  <fc-dropdown #dropdownCart fcStyleClass="fc-dropdown right-0">
    <div class="cart w-80 rounded-md bg-white shadow-xl">
      <div *ngIf="cart">
        <div
          class="border-b border-b-primary-main px-3 py-2 font-bold text-primary-darkest">
          Shopping Cart
        </div>
        <ng-container *ngIf="cart.cartItems?.length">
          <div
            class="max-h-[384px] divide-y divide-primary-main overflow-y-auto">
            <div
              class="grid cursor-pointer grid-cols-4 items-center gap-1 px-3 py-2 hover:bg-black/5"
              *ngFor="let cartItem of cart.cartItems">
              <picture class="place-self-center">
                <img
                  class="h-12 w-12"
                  [src]="
                    cartItem.product_default_image_path[0].extra_small.path
                  "
                  alt="product dummy" />
              </picture>
              <div class="col-span-3 text-xs text-primary-darkest">
                <span class="font-bold uppercase">{{
                  cartItem.brand_name
                }}</span>
                <div class="truncate capitalize">
                  {{ cartItem.product_name }}
                </div>
                <div class="mt-2 flex justify-between">
                  <span>Qty : {{ cartItem.quantity }}</span>
                  <span class="font-bold">{{
                    cartItem.totalPrice | fcCurrency
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="border-t border-primary-main p-3">
            <div
              class="mb-2 flex justify-between text-sm font-bold text-primary-darkest">
              <span>Totals</span>
              <span>{{ cart.totalCartPrice | fcCurrency }}</span>
            </div>
            <div class="flex space-x-3 text-sm">
              <button
                type="button"
                class="w-full rounded-md border border-primary-md-dark p-1 text-primary-md-dark duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white"
                [routerLink]="['/cart']">
                View Cart
              </button>
              <button
                type="button"
                class="w-full rounded-md bg-primary-md-dark p-1 text-white duration-200 ease-in-out hover:bg-primary-darkest"
                routerLink="/checkout">
                Checkout
              </button>
            </div>
          </div>
        </ng-container>
        <div
          class="mx-auto mt-1 w-full max-w-[200px] p-3 text-center text-primary-darkest"
          *ngIf="!cart.cartItems?.length">
          <img
            src="assets/images/product/no-result-search-dummy.png"
            class="illust mx-auto" />
          <div class="text-sm font-medium">
            Cart is empty.
            <br />
            <a
              class="text-primary-md-dark/80 hover:text-primary-md-dark"
              routerLink="/product">
              Start shopping now
            </a>
          </div>
        </div>
      </div>
    </div>
  </fc-dropdown>
</div>
